import { render, staticRenderFns } from "./DeleteCustomerModal.vue?vue&type=template&id=445449d1&scoped=true&"
import script from "./DeleteCustomerModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445449d1",
  null
  
)

export default component.exports